export default {
  name: 'money',
  fn(value) {
    return (Number(value) ?? 0).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  },
};
